import { fromJS } from 'immutable'
import {
  PROJECT_CODE_NON_SERVICE_EDIT_REQUEST,
  PROJECT_CODE_NON_SERVICE_EDIT_SUCCESS,
  PROJECT_CODE_NON_SERVICE_EDIT_FAILURE,
  PROJECT_CODE_NON_SERVICE_EDIT_RESET,
} from '../../actions/project-code/types'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case PROJECT_CODE_NON_SERVICE_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case PROJECT_CODE_NON_SERVICE_EDIT_SUCCESS:
      return state
        .set('isFetching', false)
        .set('status', 200)
        .set('type', 'success')
        // .set('status', 'Updated Successfully')
        .set('message', 'The data had successfully been updated')
        .set('updatedProject', fromJS(action.payload.updatedProject))
    case PROJECT_CODE_NON_SERVICE_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('type', 'error')
        .set('status', 'Error')
        .set('updatedProject', fromJS(action.payload.message))
        .set('message', fromJS(action.payload.response.message))
    case PROJECT_CODE_NON_SERVICE_EDIT_RESET:
      return state
        .set('isFetching', false)
        .set('type', null)
        .set('status', null)
        .set('updatedProject', null)
        .set('message', null)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project-code/project-non-service-edit-reducer.js